import { useState } from 'react';
import { PaginationProps } from 'antd';

const firstPage = 1,
  defaultLimit = 10;

interface Props {
  limit?: number;
}

export const usePagination = (props: Props = { limit: defaultLimit }) => {
  const [page, setPage] = useState(firstPage);
  const [limit, setLimit] = useState(props.limit || defaultLimit);
  const [total, setTotal] = useState(0);

  const onPaginationChange = (value: PaginationProps) => {
    if (value.current) {
      setPage(value.current);
    }
    if (value.pageSize) {
      setLimit(value.pageSize);
    }
  };

  return {
    page,
    limit,
    total,
    setPage,
    setLimit,
    setTotal,
    defaultLimit,
    firstPage,
    onPaginationChange,
  };
};
